import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(
        u.role === "admin" || u.role === "owner"
          ? "/admin"
          : u.role === "cashier" || u.role === "associate" || u.role === "manager"
          ? "/pos"
          : u.role === "driver"
          ? "/driver"
          : u.role === "sales_rep"
          ? "/sales-rep/dashboard"
          : "/account"
      );
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="login-page">
      <div className="ipv-eyebrow text-[#0A1C40]">Account</div>
      <h1 className="font-display font-black text-4xl tracking-tighter mt-3">Sign in</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-4">
        <input
          type="email"
          required
          placeholder="Email"
          className="input-base"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="login-email"
        />
        <input
          type="password"
          required
          placeholder="Password"
          className="input-base"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="login-password"
        />
        <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="login-submit-btn">
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <div className="text-sm text-gray-600 mt-6">
        No account?{" "}
        <Link to="/register" className="text-[#0A1C40] font-bold hover:underline" data-testid="register-link">
          Create one
        </Link>
      </div>
      <div className="text-sm text-gray-500 mt-3 border-t border-gray-100 pt-4">
        Want to <strong>earn 10%</strong> on every referral?{" "}
        <Link to="/sales-rep/signup" className="text-[#0A1C40] font-bold hover:underline" data-testid="sales-rep-signup-link">
          Become a sales rep →
        </Link>
      </div>
    </div>
  );
}
